import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { format } from "date-fns";
import { useParams } from "react-router-dom";

import InstanceLeftSidebar from "./InstanceLeftSidebar";
import {Formik, Form } from 'formik'
import { ToastContainer, toast } from 'react-toastify'
import * as Yup from "yup";
import axios from "axios";
import { useStripe, CardCvcElement, useElements } from "@stripe/react-stripe-js";
import { Country, State, City } from "country-state-city";
import { CardElement } from "@stripe/react-stripe-js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CompleteRegistration from "../../components/CompleteRegistration";
import StripeWrapper from "../../components/StripeWrapper"
import AddPaymentMethodForPurchase from "../../components/AddPaymentMethodForPurchase"
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { AuthContext } from "../../helpers/AuthContext";


function InstancePaymentFailed() {
  let { instanceUniqueId } = useParams();

  return (
    <div className="instance-dashboard">
      <ToastContainer/>
      <div className="rightSide place-items-top">
      { 
        <StripeWrapper>
          <AddPaymentMethodForPurchase paymentFailedStatus={true}/>
        </StripeWrapper>
      }
      </div>
    </div>
  );


  return (
  <StripeWrapper>
    <AddPaymentMethodForPurchase isItAPurchase={true}/>
  </StripeWrapper>
  )
}

export default InstancePaymentFailed;
